<template>
  <div :class="$style.visibilityWrapper">
    <label
      :class="$style.visibilityLabel"
      :data-test-id="$testId('ShowInUserPortalLabel')"
    >
      Show in User Portal
    </label>
    <div
      :class="$style.visibilityText"
      :data-test-id="$testId('ShowInUserPortalText')"
    >
      {{ item.isBookmark ? visibilityBookmarkText : visibilityAppText }}
    </div>
    <Checkbox
      :class="$style.visibilityCheckbox"
      :data-test-id="$testId('ShowInUserPortalCheckbox')"
      label="Show this application in User Portal"
      :value="showAppInUserPortal"
      @input="handleShowAppCheckbox"
    />
  </div>
</template>

<script>
import {
  Checkbox,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions, mapGetters, mapState } from 'vuex';

const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

export default {
  name: 'ApplicationVisibility',

  components: {
    Checkbox,
  },

  data() {
    const visibilityAppText = 'Applications appear in the User Portal for any bound users by default. When deselected, the application will not appear in the User Portal for any users and any users bound to the application will still be enabled for SSO access.';
    const visibilityBookmarkText = 'Applications appear in the User Portal for any bound users by default. When deselected, the application will not appear in the User Portal for any users.';

    return {
      visibilityAppText,
      visibilityBookmarkText,
    };
  },

  computed: {
    ...mapState(applicationModel, [
      'item',
    ]),
    ...mapGetters(applicationModel, [
      'ssoHidden',
    ]),

    showAppInUserPortal() {
      return !this.ssoHidden;
    },
  },

  methods: {
    ...mapActions(applicationModel, [
      'setSsoHidden',
    ]),

    handleShowAppCheckbox() {
      const hidden = this.showAppInUserPortal;
      this.setSsoHidden(hidden);
    },
  },
};
</script>
<style module>
.visibilityCheckbox {
  display: block;
  font-size: 13px;
  margin-top: 1.66em;
}

.visibilityLabel {
  display: block;
  font-weight: 600;
  margin: 0 0 0.5rem;
  text-transform: capitalize;
}

.visibilityText {
  text-align: justify;
}

.visibilityWrapper {
  margin-bottom: 1.33em;
  margin-top: 1.33em;
}
</style>
